import { DateTime } from 'luxon'

import { RoyaltyResponseDTO } from '@core/api/dtos/response/misc/royalty'
import { Royalty } from '@core/api/entities/misc/royalty'

export class RoyaltyMapper {
	static toEntity(dto: RoyaltyResponseDTO): Royalty {
		return Royalty.create({
			id: dto.id,
			name: dto.name,
			default: dto.default,
			createdAt: dto.created_at ? DateTime.fromISO(dto.created_at) : undefined,
			updatedAt: dto.updated_at ? DateTime.fromISO(dto.updated_at) : undefined,
		})
	}

	static toEntities(dtos: RoyaltyResponseDTO[]): Royalty[] {
		return dtos.map(this.toEntity)
	}
}
